import React from 'react';
import { FaFacebook, FaTwitter, FaLinkedin } from 'react-icons/fa';

export const socialData = [
  {
    id: 1,
    icon: <FaFacebook className="icon" />,
    url: 'https://facebook.com'
  },
  {
    id: 2,
    icon: <FaTwitter className="icon" />,
    url: 'https://facebook.com'
  },
  {
    id: 3,
    icon: <FaLinkedin className="icon" />,
    url: 'https://facebook.com'
  }
]